// client/src/components/Admin/StatsRenderer.js
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import Assignment from "@material-ui/icons/Assignment";

const styles = {
  cardCategory: {
    color: "#999",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitle: {
    color: "#3C4858",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

const StatsRenderer = ({
  statNumeric,
  userData,
  registrationData,
  attendanceData,
  userEmailsString,
  researchCoordinatorEmailsString,
  dataRequestsData,
  voteData,
  onAddUser,
}) => {
  const classes = useStyles();

  const renderStatsContent = () => {
    switch (statNumeric) {
      case "1":
        return (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardTitle}>Users</h4>
              </CardHeader>
              <CardBody>
                <Button
                  round
                  color="info"
                  onClick={onAddUser}
                  style={{ marginBottom: "20px" }}
                >
                  Add User
                </Button>
                <ReactTable
                  columns={[
                    { Header: "Name", accessor: "name" },
                    { Header: "Email", accessor: "email" },
                    { Header: "Institution", accessor: "institution" },
                    { Header: "Type", accessor: "type" },
                    { Header: "Actions", accessor: "actions" },
                  ]}
                  data={userData}
                  defaultPageSize={20}
                />
              </CardBody>
            </Card>
          </GridItem>
        );

      case "2":
        return (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardTitle}>
                  Registrations - Current Meeting
                </h4>
              </CardHeader>
              <CardBody>
                <h4>Total: {registrationData.total}</h4>
                <h4>In Person: {registrationData.inPerson}</h4>
                <h4>Virtual: {registrationData.virtual}</h4>
                <br />
                <ReactTable
                  columns={[
                    { Header: "Name", accessor: "name" },
                    { Header: "Institution", accessor: "institution" },
                    {
                      Header: "Registration Type",
                      accessor: "registration_type",
                    },
                    {
                      Header: "Need Time?",
                      accessor: "need_time",
                    },
                    { Header: "Actions", accessor: "actions" },
                  ]}
                  data={registrationData.data}
                  defaultPageSize={20}
                />
              </CardBody>
            </Card>
          </GridItem>
        );

      case "3":
        return (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardTitle}>Attendance</h4>
              </CardHeader>
              <CardBody>
                {/* Attendance Summary */}
                {attendanceData.summary &&
                  Object.keys(attendanceData.summary).length > 0 && (
                    <div style={{ marginBottom: "20px" }}>
                      {Object.entries(attendanceData.summary).map(
                        ([meeting, count]) => (
                          <h4 key={meeting} style={{ margin: "5px 0" }}>
                            {meeting}: {count}
                          </h4>
                        )
                      )}
                      <br />
                    </div>
                  )}

                {/* Attendance Table */}
                <ReactTable
                  columns={[
                    { Header: "Name", accessor: "name" },
                    { Header: "Email", accessor: "email" },
                    { Header: "Type", accessor: "type" },
                    { Header: "Date/Time", accessor: "dateTime" },
                  ]}
                  data={attendanceData.data || attendanceData}
                  defaultPageSize={20}
                />
              </CardBody>
            </Card>
          </GridItem>
        );

      case "4":
        return (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardTitle}>User Email List</h4>
              </CardHeader>
              <CardBody>
                <h4>
                  User Email List (excluding Research Coordinators):
                  <br />
                  <br />
                  {userEmailsString}
                </h4>
              </CardBody>
            </Card>
          </GridItem>
        );

      case "5":
        return (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardTitle}>
                  Research Coordinator Email List
                </h4>
              </CardHeader>
              <CardBody>
                <h4>
                  Research Coordinator Email List:
                  <br />
                  <br />
                  {researchCoordinatorEmailsString}
                </h4>
              </CardBody>
            </Card>
          </GridItem>
        );

      case "6":
        return (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardTitle}>Data Requests</h4>
              </CardHeader>
              <CardBody>
                <ReactTable
                  columns={[
                    { Header: "Name", accessor: "name" },
                    { Header: "Action", accessor: "actions" },
                  ]}
                  data={dataRequestsData}
                  defaultPageSize={20}
                />
              </CardBody>
            </Card>
          </GridItem>
        );

      case "7":
        return (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardTitle}>Votes</h4>
              </CardHeader>
              <CardBody>
                <h4>Guillaume Emeriaud: {voteData.emeriaud}</h4>
                <h4>Samer Abu-Sultaneh: {voteData.abusultaneh}</h4>
                <h4>Jocelyn R. Grunwell: {voteData.grunwell}</h4>
              </CardBody>
            </Card>
          </GridItem>
        );

      default:
        return null;
    }
  };

  return renderStatsContent();
};

StatsRenderer.propTypes = {
  statNumeric: PropTypes.string.isRequired,
  userData: PropTypes.array.isRequired,
  registrationData: PropTypes.shape({
    total: PropTypes.number,
    inPerson: PropTypes.number,
    virtual: PropTypes.number,
    data: PropTypes.array,
  }).isRequired,
  attendanceData: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({
      data: PropTypes.array,
      summary: PropTypes.object,
    }),
  ]).isRequired,
  userEmailsString: PropTypes.string.isRequired,
  researchCoordinatorEmailsString: PropTypes.string.isRequired,
  dataRequestsData: PropTypes.array.isRequired,
  voteData: PropTypes.shape({
    emeriaud: PropTypes.number,
    abusultaneh: PropTypes.number,
    grunwell: PropTypes.number,
  }).isRequired,
  onAddUser: PropTypes.func,
};

export default StatsRenderer;

